/* eslint-disable @typescript-eslint/no-explicit-any */
import type { GetServerSideProps } from 'next';
import { getServerSession } from 'next-auth/next';

import {
  slugIndexServerSideProps,
  SlugIndexRouting,
  SlugRoutingProps,
} from '@edelman/storyblok-ui';
import { nextAuthCheck } from '@edelman/storyblok-ui/src/utils';

import { authOptions } from '../api/auth/[...nextauth]';

export const getServerSideProps: GetServerSideProps<SlugRoutingProps, any> = async context => {
  // Get processed page props
  const pageProps: any = await slugIndexServerSideProps(context);
  if (pageProps?.redirect) return pageProps;

  // Check page auth
  if (process.env.AUTH_ENABLED === 'true') {
    const { req, res } = context;
    const { slugFromParams, rootFolder, rawSbReqInfo } = pageProps.props;
    const userSession: any = await getServerSession(req, res, authOptions);
    const authCheck = await nextAuthCheck({
      userSession,
      slugFromParams,
      rootFolder,
      rawSbReqInfo,
    });
    if (authCheck !== false) return authCheck;
  }

  return pageProps;
};

export default SlugIndexRouting;
